var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"religiao","rota-base":"/admin/religiao","titulo":"RELIGIÕES","titulo-singular":"Religião","colunas-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }